// src/app/core/auth/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.token();

  // No token at all
  if (!token) {
    return router.createUrlTree(['/login']);
  }

  // Check JWT expiry (manual decode per D-06 -- no external library)
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      // Invalid JWT format -- treat as expired
      authService.logout();
      return router.createUrlTree(['/login']);
    }
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (typeof payload.exp === 'number' && payload.exp * 1000 < Date.now()) {
      authService.logout(); // sync clear
      return router.createUrlTree(['/login']);
    }
  } catch {
    // Invalid token format -- treat as expired
    authService.logout();
    return router.createUrlTree(['/login']);
  }

  // Requires password change -- redirect to change-password page
  if (authService.requiresPasswordChange()) {
    return router.createUrlTree(['/access/change-password']);
  }

  return true;
};
